<article
  *ngIf="cardContent"
  role="article"
  class="card"
  [attr.isSmall]="isSmall"
  (keydown.enter)="displayDropDown$.next(!displayDropDown$.value)"
  (mouseleave)="displayDropDown$.next(false)"
>
  <img
    class="card__image"
    [attr.isSmall]="isSmall"
    [src]="cardContent.img | imaginarySrc: 1:324"
    [srcset]="cardContent.img | imaginarySrc: 4:324"
    alt=""
    loading="lazy"
  />

  <div class="card__content">
    <header role="banner" class="card__info">
      <h3 class="card__title" [attr.isSmall]="isSmall">{{ cardContent.title }}</h3>
      <p *ngIf="cardContent.description" class="card__description" [attr.isSmall]="isSmall">
        {{ cardContent.description }}
      </p>
    </header>

    <ng-container
      *ngIf="
        !(cardContent.link && cardContent.dropdown) &&
          (cardContent.link || cardContent.modalContactType || cardContent.url);
        else dropdownTemplate
      "
    >
      <a
        *ngIf="cardContent.link"
        class="btn card__btn"
        [routerLink]="cardContent.link"
        [attr.aria-label]="'Ouvrir le lien de ' + cardContent.title"
        (click)="trackOnClick()"
      >
        <mat-icon class="card__btn__icon" svgIcon="arrow_next"></mat-icon>
      </a>

      <a
        *ngIf="cardContent.url"
        class="btn card__btn"
        [href]="cardContent.url"
        target="_blank"
        [attr.aria-label]="'Ouvrir le lien de ' + cardContent.title"
        (click)="trackOnClick()"
      >
        <mat-icon class="card__btn__icon" svgIcon="arrow_next"></mat-icon>
      </a>

      <button
        type="button"
        *ngIf="cardContent.modalContactType"
        class="btn card__btn"
        (click)="openModal()"
        [attr.aria-label]="'Ouvrir la modal de contact ' + cardContent.title"
      >
        <mat-icon class="card__btn__icon" svgIcon="arrow_next"></mat-icon>
      </button>
    </ng-container>
  </div>
</article>

<ng-template #dropdownTemplate>
  <button
    class="btn card__btn card__btn--dropdown"
    [class.card__btn--clicked]="(displayDropDown$ | async) === true"
    [attr.aria-label]="'Ouvrir la modal de contact ' + cardContent.title"
    type="button"
    (keydown.enter)="displayDropDown$.next(!displayDropDown$.value)"
  >
    <mat-icon class="card__btn__icon" svgIcon="arrow_next" role="presentation"></mat-icon>
  </button>

  <ul *ngIf="(displayDropDown$ | async) === true" class="card__dropdown">
    <li *ngFor="let item of cardContent.dropdown; trackBy: trackByDropDownItem" class="card__dropdown__item">
      <a
        *ngIf="!!item.link && !item.url"
        (click)="dropDownItemClicked(item.trackEventAction)"
        [routerLink]="item.link"
        routerLinkActive="card__dropdown__item--active"
        [queryParams]="item.queryParams"
        >{{ item.title }}</a
      >

      <a
        *ngIf="!!item.url && !item.link"
        (click)="dropDownItemClicked(item.trackEventAction)"
        [href]="item.url"
        target="_blank"
        routerLinkActive="card__dropdown__item--active"
        >{{ item.title }}</a
      >
    </li>
  </ul>
</ng-template>
